import React from "react";
// import { Player, ControlBar, PlayToggle, BigPlayButton } from "video-react";
import "../../../node_modules/video-react/dist/video-react.css";
import autoBind from "react-autobind";
import {
	Button
} from "react-bootstrap";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import _ from "lodash";

import state from "../../state";

import { markdownToHtml } from "../../utils/markupUtils";
import { itemHasVideo, itemHasImage, itemHasPdf, handleOpenInNewTab } from "../../utils/utils";
import { getUrlForValue } from "../../actions/drive";
import { getSelectedActivityId, showImagePreview } from "../../actions/playerActions";
import PlayerItemVideo from "./PlayerItemVideo";

import { isIos/*, isIphone*/ } from "../../utils/browserUtils";
import { generateFluidFontSizeStyling } from "../../utils/utils";

import { evalItemText } from "../../utils/runtimeApiUtils";

// import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";


// import { getConfigParam } from "../../utils/config";

const hoc = (WrappedComponent) => {
	class PlayerItemHoc extends React.PureComponent {

		constructor(props) {
			super(props);
			this.videoPlayer = React.createRef();
			this.state = {
				readInline: {},
				playerMuted: true
			};
			autoBind(this);
		}

		getActivityItemPath(delimiter) {
			if (this.props) {
			const { listIndex, sectionIndex, itemIndex } = this.props;
			return listIndex + delimiter + sectionIndex + delimiter + itemIndex;
			} else {
				return "?";
			}
		}

		handleReadInline() {
			const { item } = this.props;
			const { guid } = item;
		
			if (guid) {
				// console.log("HANDLE READ INLINE", item, guid, this.state);
				const readInline = _.cloneDeep(this.state.readInline);
				readInline[guid] = true;
				this.setState({ readInline });
			}
		}

		// getImageWorking() {
		// 	const item = this.props.item;

		// 	let image;

		// 	// const webMode = getConfigParam("webMode", false);

		// 	if (itemHasImage(item)) {
		// 		const url = getUrlForValue(item.image, getSelectedActivityId());


		// 		image = <img alt="" className="player-image" src={url} onClick={() => { showImagePreview(); }} />;

		// 		// image =
		// 		// 	<div>
		// 		// 		<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
		// 		// 		<div>
		// 		// 			<a href={url} target='blank'><img alt="" style={{ maxWidth: "100%" }} src={url} /></a>
		// 		// 			</div>
		// 		// 		</div>
		// 		// 		{/* !webMode && <Button style={{ marginTop: "10px", marginBottom: "10px" }} onClick={() => { handleOpenInNewTab(url); }}><FontAwesomeIcon icon="external-link" /> View In New Tab</Button> */}
		// 		// 	</div>;
		// 	}
		// 	return image;
		// }

		// getImageAlt() {
		// 	const item = this.props.item;

		// 	let image;

		// 	// const webMode = getConfigParam("webMode", false);

		// 	if (itemHasImage(item)) {
		// 		const url = getUrlForValue(item.image, getSelectedActivityId());

		// 		image =
		// 			<div style={{display: "flex", flexDirection: "column", width: "100%", height: "50vh"}}>
		// 				<div style={{flex: 1, backgroundColor: "rgba(128,128,128,0.3)", width: "100%", height: "0"}}>
		// 					<img alt="" className="player-image" src={url} onClick={() => { showImagePreview(); }} />
		// 				</div>
		// 				<div style={{flex: 0, display: "flex", flexDirection: "row", justifyContent: "center", alignItems:"center", marginTop: "10px", marginBottom: "10px"}}>
		// 					<Button onClick={() => { showImagePreview(); }}><FontAwesomeIcon icon="arrows-alt" /> View Fullscreen</Button>
		// 				</div>
		// 			</div>;	
		// 	}
		// 	return image;
		// }

		// getImageAlt2() {
		// 	const item = this.props.item;

		// 	let image;

		// 	// const webMode = getConfigParam("webMode", false);

		// 	if (itemHasImage(item)) {
		// 		const url = getUrlForValue(item.image, getSelectedActivityId());

		// 		image =
		// 			<div style={{display: "flex", flexDirection: "column", width: "100%", maxHeight: "50vh", position: "relative"}}>
		// 				<div style={{height: "100%"}}>
		// 					<div style={{display: "flex", flexDirection: "column", backgroundColor: "rgba(128,128,128,0.3)", width: "100%"}}>
		// 						<img alt="" style={{flex: 1}} className="player-image" src={url} onClick={() => { showImagePreview(); }} />
		// 						<div style={{flex: 0, display: "flex", flexDirection: "row", justifyContent: "center", alignItems:"center", marginTop: "10px", marginBottom: "10px"}}>
		// 							<Button onClick={() => { showImagePreview(); }}><FontAwesomeIcon icon="arrows-alt" /> View Fullscreen</Button>
		// 						</div>
		// 					</div>
		// 				</div>
		// 			</div>;	
		// 	}
		// 	return image;
		// }

		onLoadImage() {
			const { listIndex, sectionIndex, itemIndex } = this.props;

			const pos = listIndex + "," + sectionIndex + "," + itemIndex;

			global.loadedImagesHash[pos] = "loaded";
		}

		onErrorImage() {
			const { listIndex, sectionIndex, itemIndex } = this.props;

			const pos = listIndex + "," + sectionIndex + "," + itemIndex;

			global.loadedImagesHash[pos] = "error";
		}

		getLabelsReadOnly() {
			const { item } = this.props;

			const { styleLabel1, styleLabel2 } = this.getLabelStyles();

			const label1 = evalItemText(item,item.label1);
			const label2 = evalItemText(item,item.label2);

			let labels;

			labels =
				<div>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(label1, { readOnlyLinks: true })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(label2, { readOnlyLinks: true })} />
				</div>;

			return labels;
		}

		getLabels() {
			const { item, listIndex, sectionIndex, itemIndex } = this.props;

			const { styleLabel1, styleLabel2 } = this.getLabelStyles();

			const label1 = evalItemText(item,item.label1);
			const label2 = evalItemText(item,item.label2);

			let labels;

			labels =
				<div>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(label1, { listIndex, sectionIndex, itemIndex })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(label2, { listIndex, sectionIndex, itemIndex })} />
				</div>;

			return labels;
		}

		getLabelsShowMode() {
			let labels;

			const { item, useCustomShowModeStyling, _showModeTextAlign } = this.props;

			const { showModeTextAlign } = item;

			const label1 = evalItemText(item,item.label1);
			const label2 = evalItemText(item,item.label2);

			let align = "";
			if (showModeTextAlign || _showModeTextAlign) {
	
				const targetShowModeTextAlign = showModeTextAlign ? showModeTextAlign : _showModeTextAlign;
	
				align = " " + targetShowModeTextAlign.split("-").join(" ");
			}

			const { styleLabel1, styleLabel2 } = this.getLabelStyles(false);
			let additionalPropsLabel1 = {};
			let additionalPropsLabel2 = {};
			if (useCustomShowModeStyling === true) {
				const label1FluidFontStyle = generateFluidFontSizeStyling(styleLabel1, .5, "calc(20px + (36 - 20) * ((100vw - 300px) / (1600 - 300)))");
				additionalPropsLabel1.style = styleLabel1 ? _.cloneDeep(styleLabel1) : {};
				additionalPropsLabel1.style.fontSize = label1FluidFontStyle;
	
	
				const label2FluidFontStyle = generateFluidFontSizeStyling(styleLabel2, .5, "calc(16px + (30 - 16) * ((100vw - 300px) / (1600 - 300)))");
				additionalPropsLabel2.style = styleLabel2 ? _.cloneDeep(styleLabel2) : {};
				additionalPropsLabel2.style.fontSize = label2FluidFontStyle;
			}
	
			labels =
				<>
					{(window.innerWidth*window.innerHeight <= 200000) &&
					<div className={`player-show-mode-label-item-container${align}`}>
						<h5 {...additionalPropsLabel1} dangerouslySetInnerHTML={markdownToHtml(label1)} />
						<h6 {...additionalPropsLabel2} dangerouslySetInnerHTML={markdownToHtml(label2)} />
					</div>
					}
					{(window.innerWidth*window.innerHeight > 200000 && window.innerWidth*window.innerHeight <= 300000) &&
					<div className={`player-show-mode-label-item-container${align}`}>
						<h4 {...additionalPropsLabel1} dangerouslySetInnerHTML={markdownToHtml(label1)} />
						<h5 {...additionalPropsLabel2} dangerouslySetInnerHTML={markdownToHtml(label2)} />
					</div>
					}
					{(window.innerWidth*window.innerHeight > 300000 && window.innerWidth*window.innerHeight <= 360000) &&
					<div className={`player-show-mode-label-item-container${align}`}>
						<h3 {...additionalPropsLabel1} dangerouslySetInnerHTML={markdownToHtml(label1)} />
						<h4 {...additionalPropsLabel2} dangerouslySetInnerHTML={markdownToHtml(label2)} />
					</div>
					}
					{(window.innerWidth*window.innerHeight > 360000) &&
					<div className={`player-show-mode-label-item-container${align}`}>
						{/* <p>{window.innerHeight + "; " + window.innerWidth}</p> */}
						<h2 {...additionalPropsLabel1} dangerouslySetInnerHTML={markdownToHtml(label1)} />
						<h3 {...additionalPropsLabel2} dangerouslySetInnerHTML={markdownToHtml(label2)} />
					</div>
					}
				</>;

			return labels;
		}

		getImage() {
			// console.log("getImage");
			const item = this.props.item;

			let image;

			// const webMode = getConfigParam("webMode", false);

			if (itemHasImage(item)) {
				const url = getUrlForValue(item.image, getSelectedActivityId());

				image =
				<div style={{display: "flex", flexDirection: "column", width: "100%"}}>
					<img alt="" style={{flex: 1, maxHeight: "40vh"}} className="player-image" src={url} onClick={(e) => { e.stopPropagation(); showImagePreview(state,url); }} onLoad={()=> {this.onLoadImage();}} onError={()=>{this.onErrorImage();}}/>
					{(_.isString(url) && url !== "") &&
					<div style={{flex: 0, display: "flex", flexDirection: "row", justifyContent: "center", alignItems:"center", marginTop: "10px", marginBottom: "10px"}}>
						<Button onClick={(e) => { e.stopPropagation(); showImagePreview(state,url); }}><FontAwesomeIcon icon="arrows-alt" /> {state.get(["content"]).items.image.showFullscreen}</Button>
					</div>
					}
				</div>;
			}
			return image;
		}

		getImageShowMode() {
			const item = this.props.item;

			let image;

			if (itemHasImage(item)) {
				const url = getUrlForValue(item.image, getSelectedActivityId());
				image = <img alt="Show Mode" className="player-show-mode-image" src={url} onClick={(e) => { e.stopPropagation(); this.onClickShowModeImage(url); }} onLoad={()=> {this.onLoadImage();}} onError={()=>{this.onErrorImage();}}/>;
			}
			return image;
		}

		getVideo(videoRef) {
			const item = this.props.item;

			const { listIndex, sectionIndex, itemIndex } = this.props;


			console.log("HAS VIDEO", itemHasVideo(item), this.props);
			let video;

			if (itemHasVideo(item)) {
				const url = getUrlForValue(item.video, getSelectedActivityId());					
				video = <PlayerItemVideo 
					url={url} 
					playerMuted={this.state.playerMuted} 
					videoRef={videoRef} 
					selected={this.props.selected} 
					loop={false} 
					autoPlay={this.props.selected}
					listIndex={listIndex}
					sectionIndex={sectionIndex}
					itemIndex={itemIndex}/>;				
			}

			return video;
		}

		getPdf() {
			const { item } = this.props;

			let pdf;
			// console.log("GET PDF");
			if (itemHasPdf(item)) {
				const url = getUrlForValue(item.pdf, getSelectedActivityId());
				const showPdfActions = !this.state.readInline[item.guid];
				// console.log("SHOW PDF ACTIONS", item.guid, showPdfActions);
				pdf = <div style={{position: "relative", width: "100%"}}>
					{!isIos() && showPdfActions && <div class="pdf-actions">
						<div>
							<Button style={{ marginTop: "10px", marginBottom: "10px" }} onClick={this.handleReadInline}><FontAwesomeIcon icon="hand-point-down" /><br />Read Inline</Button><Button style={{ marginTop: "10px", marginBottom: "10px" }} onClick={() => { handleOpenInNewTab(url); }}><FontAwesomeIcon icon="external-link" /><br />View in New Tab</Button>
						</div>
					</div>}
					{!isIos() &&
						<div style={{display: "flex", flexDirection: "column", width: "100%"}}>
							<div style={{width: "100%", backgroundColor: isIos() ? "white":"transparent"  }}>
								<object style={{width: "100%", height: "40vh"}} data={url+"#view=fitV,100"} type="application/pdf" internalinstanceid="9" title="">
									<p style={{margin: "5px", color: "black"}}>Your browser doesn't support embedded pdf files. You can download the file.
									<a style={{color: "blue"}} href={url}> Click here to download the file.</a></p>
								</object>
							</div>
							{!showPdfActions && <div style={{flex: 0, display: "flex", flexDirection: "row", justifyContent: "center", alignItems:"center", marginTop: "10px", marginBottom: "10px"}}>
								<Button onClick={() => { handleOpenInNewTab(url); }}><FontAwesomeIcon icon="external-link" /> View in New Tab</Button>
							</div>
						}
						</div>
					}
					{isIos() &&
						<div style={{display: "flex", flexDirection: "column", width: "100%"}}>
							<div style={{width: "100%", backgroundColor: isIos() ? "white":"transparent"  }}>
								<object style={{width: "100%", height: "40vh"}} data={url+"#view=fitV,100"} type="application/pdf" internalinstanceid="9" title="">
									<p style={{margin: "5px", color: "black"}}>Your browser doesn't support embedded pdf files. You can download the file.
									<a style={{color: "blue"}} href={url}> Click here to download the file.</a></p>
								</object>
							</div>
							<div style={{flex: 0, display: "flex", flexDirection: "row", justifyContent: "center", alignItems:"center", marginTop: "10px", marginBottom: "10px"}}>
								<Button onClick={() => { handleOpenInNewTab(url); }}><FontAwesomeIcon icon="external-link" /> View in New Tab</Button>
							</div>
						</div>
					}

				</div>;
			}

			return pdf;
		}

		getVideoShowMode(ref) {
			const item = this.props.item;

			const { listIndex, sectionIndex, itemIndex } = this.props;

			let video;

			if (itemHasVideo(item)) {
				const url = getUrlForValue(item.video, getSelectedActivityId());					
				video = <PlayerItemVideo
					url={url} 
					playerMuted={false} 
					videoRef={ref} 
					loop={false} 
					autoPlay={false} 
					showMode={true} 
					showFullscreenToggle={false}
					listIndex={listIndex}
					sectionIndex={sectionIndex}
					itemIndex={itemIndex}
				/>;				
			}

			return video;
		}


		onClickShowModeImage(url) {
			if (this.props.onClickShowModeImage) {
				this.props.onClickShowModeImage(url);
			}
		}

		getAcceptDefaultButton(defaultValueProp, onClickHandler) {
			const item = this.props.item;

			let component;

			//if we have a default value defined and component isn't completed we want to show this button if showAcceptDefaultButton=true
			if (this.props.showAcceptDefaultButton &&
				!_.isUndefined(item[defaultValueProp]) &&
				item[defaultValueProp] !== "" &&
				item.checked === false) {

				component = <div>
					<Button bsStyle="primary" onClick={onClickHandler}>Accept Default</Button>
				</div>;
			}

			return component;
		}

		getLabelStyles(markChecked=true) {
			// console.log("getLabelStyles", this);
			const { item } = this.props;
			const { resolvedStyles } = item;

			let itemStyle;
			let styleLabel1;
			let styleLabel2;

			if (!_.isUndefined(resolvedStyles)) {
				itemStyle = resolvedStyles.item;
				styleLabel1 = resolvedStyles.label1;
				styleLabel2 = resolvedStyles.label2;
			}

			if (item.checked && markChecked) {
				const theme = window.activityTheme;
				styleLabel1 = _.assign({}, styleLabel1, theme.item.checked);
				styleLabel2 = _.assign({}, styleLabel2, theme.item.checked);
			}

			return {
				item: itemStyle,
				styleLabel1,
				styleLabel2
			};
		}

		render() {

			let wrappedComponent = <WrappedComponent
				getLabels={this.getLabels}
				getLabelsReadOnly={this.getLabelsReadOnly}
				getLabelsShowMode={this.getLabelsShowMode}
				getImage={this.getImage}
				getImageShowMode={this.getImageShowMode}
				getVideo={this.getVideo}
				getVideoShowMode={this.getVideoShowMode}
				getPdf={this.getPdf}
				getLabelStyles={this.getLabelStyles}
				getAcceptDefaultButton={this.getAcceptDefaultButton}
				getActivityItemPath={this.getActivityItemPath}
			parentState={this.state}
				{...this.props} />;


			return wrappedComponent;
		}

	}

	return PlayerItemHoc;
};

export default hoc;